import {Box, IconButton, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {LocalizedLanguages} from "./Localization";
import {Cancel, CheckCircle} from "@mui/icons-material";
import {ISubtitles} from "./LocalizedSubtitles";

const useStyles = makeStyles((theme) => ({
    blockName: {
        cursor: "pointer",
        flexGrow: 1,
        margin: theme.spacing(1),
        width: 90
    },
    language: {
        width: 30
    },
    row: {
        display: "flex",
        flexGrow: 1,
        marginRight: theme.spacing(10)
    },
    state: {
        margin: theme.spacing(1),
        width: 90
    },
    wrapped: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}));

interface ISubtitleRow {
    blockName: string
    onClick: (blockName: string, language: string) => void
    style: any
    subtitles: ISubtitles
}
export function SubtitleRow({blockName, onClick, style, subtitles}: ISubtitleRow) {
    const classes = useStyles();
    const date = new Date(subtitles.modified || 0);

    return (
        <Box display="flex" key={blockName} style={style}>
            <Box className={classes.row}>
                <Box className={classes.blockName} onClick={() => onClick(blockName, "english")}>
                    <Typography className={classes.wrapped} title={blockName}>
                        {blockName}
                    </Typography>
                </Box>
                <Box className={classes.state}>
                    <Typography className={classes.wrapped} title={subtitles.modified ? date.toLocaleString() : "Unset"}>
                        {subtitles.modified ? date.toLocaleDateString() : "Unset"}
                    </Typography>
                </Box>
                {Object.keys(LocalizedLanguages).map(language => {
                    const color = (subtitles.languages && subtitles.languages[language]) ?
                        (subtitles.modified > subtitles.languages[language].modified ? "warning" : "primary") :
                        "error";
                    const title = (subtitles.languages && subtitles.languages[language]) ?
                        new Date(subtitles.languages[language].modified).toLocaleString() : ""

                    return (
                        <Box className={classes.language} key={language}>
                            <IconButton color={color} data-key={blockName} data-language={language}
                                        onClick={() => onClick(blockName, language)} size="small" title={title}>
                                {(subtitles.languages && subtitles.languages[language]) ? <CheckCircle/> : <Cancel/>}
                            </IconButton>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
